<!-- CONTAINER -->
<div class="bg-white py-36px px-24px rounded-tl-[24px] rounded-tr-[24px]">
	<!-- HEADER SECTION -->

	<!-- filter -->
	<app-search-filter
		(keyWord)="brandsFilter.searchText = $event; getBrands()"
		[showFilter]="false"
	></app-search-filter>

	<!-- table -->
	<app-brands-table
		*ngIf="brands?.length"
		(actionChanged)="getBrands()"
		(deleteId)="deleteBrand($event)"
		(activationState)="updateBrandStatus($event)"
		[brands]="brands"
		[brandsFilter]="brandsFilter"
		[totalCount]="totalCount"
	></app-brands-table>
</div>
<app-no-data-found
	*ngIf="!brands?.length"
	text="STORE.BRANDS_LIST.NO_BRAND_YET"
></app-no-data-found>
<!-- pagination -->
<div class="mt-8 py-5 max-mobile:overflow-auto">
	<app-pagination
		[totalCount]="totalCount"
		[pageNumber]="brandsFilter.paging.pageNumber"
		[pageCount]="brandsFilter.paging.pageSize"
		(currentPage)="pagingChanged($event, brandsFilter.paging.pageSize)"
		(itemsCountPerPage)="pagingChanged(1, $event)"
	></app-pagination>
</div>

<!-- fixed button -->
<app-fixed-button
	(click)="addBrand()"
	[buttonWidth]="180"
	[buttonTitle]="'STORE.BRANDS_LIST.ADD_BRAND'"
	[imgPath]="'add-white.svg'"
></app-fixed-button>
